import * as React from "react";
import {authorize, Overlay} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {ICustomerPortalService, Policy, PRODUCT_ANNUAL_HOME, ProductsEnum, Types} from "@falcon/services";
import {finalize} from "rxjs/operators";
import {getAddress} from "../../../../../CommonFunctions";
import {ButtonLink} from "../../../../../components/navigation/ButtonLink";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import {
    Detail,
    DetailKey,
    DetailValue,
    SectionContents,
    SectionHeading,
    convertDateTime,
    renderCoverStartDate
} from "@falcon/plugin-falcon-journey";


interface IOldPoliciesPageProps {
}

interface IOldPoliciesPageState {
    isLoading: boolean;
    isLoadingHistory: boolean;

    expiredPolicies: Policy[];
    hasOldMotorPolicies: boolean;
}

@authorize
export class OldHomePoliciesPage extends React.Component<IOldPoliciesPageProps, IOldPoliciesPageState> {
    private static readonly OLD_POLICY_BEFORE_RENEWAL: string = "OLD_POLICY_BEFORE_RENEWAL";

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IOldPoliciesPageProps) {
        super(props);

        this.state = {
            isLoading: false,
            isLoadingHistory: false,
            expiredPolicies: [],
            hasOldMotorPolicies: false,
        };
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Old Policies");

        this.setState({isLoading: true}, () =>
            this.customerPortalService
                .getExpiredPolicies()
                .pipe(finalize(() => this.setState({isLoading: false})))
                .subscribe((policies: Policy[]) => {
                    const hasOldMotorPolicies = policies.filter(p => p.products.includes(ProductsEnum.WOLF_MOTOR)).length > 0
                    const homePolicies = policies.filter(p => p.products.includes(ProductsEnum.HOME))
                    const joinPolicies = this.state.expiredPolicies.concat(homePolicies);
                    this.setState({
                        expiredPolicies: joinPolicies || [],
                        hasOldMotorPolicies
                    });
                }),
        );

        this.setState({isLoadingHistory: true}, () =>
            this.customerPortalService.getPolicyHistoryAfterRenewal()
                .pipe(finalize(() => this.setState({isLoadingHistory: false})))
                .subscribe((policyHistories: Policy[]) => {
                    const homePoliciesBeforeRenewal = policyHistories.filter(p => p.products.includes(PRODUCT_ANNUAL_HOME));
                    const joinPolicies = this.state.expiredPolicies.concat(homePoliciesBeforeRenewal);
                    this.setState({
                        expiredPolicies: joinPolicies || []
                    });
                })
        );
    }

    public render() {
        return (
            <>
                <FalconHeader/>
                <Overlay show={this.state.isLoading || this.state.isLoadingHistory}/>
                <div className="page-contents">
                    {this.pluginTemplates.renderBackLink("Back", true, this.state.hasOldMotorPolicies ? `/dashboard/annualOldPolicies` : `/dashboard`)}
                    <h1 className="page-heading-white">Your previous Allianz home policies</h1>
                    {(!this.state.isLoading && this.state.expiredPolicies.length > 0) && this.renderPolicies()}
                    {this.pluginTemplates.renderBackLink("Back", false, this.state.hasOldMotorPolicies ? `/dashboard/annualOldPolicies` : `/dashboard`)}
                </div>
                <FalconFooter/>
            </>
        );
    }

    private renderPolicies = () => {
        if (this.state.expiredPolicies?.length < 1) {
            return (
                <div className="panel">
                    <p className="m-0 font-weight-extra-light">You don't have any previous policies</p>
                </div>
            );
        } else {
            return this.state.expiredPolicies.map((policy: Policy, index: number) => {
                const policyPanel: any = [];
                policyPanel.push(
                    <div className="section-panel your-old-car-cover-panel" id={`old-home-${index}`}
                         key={policy.policyNumber}>
                        <div className="section car-details">
                            <img className="main-icon home-logo" src={"/img/home-icon.png"} alt="Home icon"/>
                            <SectionHeading>
                                {getAddress(policy?.insuredRealEstates[0].address)} {policy?.insuredRealEstates[0].address.postalCode}
                            </SectionHeading>
                            <SectionContents>
                                {policy.status === OldHomePoliciesPage.OLD_POLICY_BEFORE_RENEWAL && (
                                    <Detail>
                                        <DetailKey>Status</DetailKey>
                                        <DetailValue>Expired</DetailValue>
                                    </Detail>
                                )}
                                <Detail className="cover-start-date">
                                    <DetailKey className="font-weight-semi-bold d-inline-block">Cover start
                                        date:</DetailKey>
                                    &nbsp;
                                    <DetailValue
                                        className="d-inline-block">{renderCoverStartDate(policy.startDate)}</DetailValue>
                                </Detail>
                                <Detail>
                                    <DetailKey className="font-weight-semi-bold d-inline-block">Cover expiry
                                        date:</DetailKey>
                                    &nbsp;
                                    <DetailValue
                                        className="d-inline-block">{convertDateTime(policy.endDate)}</DetailValue>
                                </Detail>
                            </SectionContents>

                            {policy.status !== OldHomePoliciesPage.OLD_POLICY_BEFORE_RENEWAL && (
                                <div className="section-links">
                                    <ButtonLink
                                        id={`old-home-summary-btn-${index}`}
                                        primary={true}
                                        to={`/dashboard/annualHomeOldPolicies/${policy.policyNumber}`}>
                                        View policy details
                                    </ButtonLink>
                                </div>
                            )}
                        </div>
                    </div>
                );
                return policyPanel;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/home/oldPolicies/OldHomePoliciesPage.tsx